import {AnyAction} from 'redux'
import {crudReducer, CrudState, initialCrudState} from 'lib/crud'

export const name = 'USER'

export type UsersState = {
    crud: CrudState,
}

const initialState = {
    crud: initialCrudState,
}

export function usersReducer(state: UsersState = initialState, action: AnyAction): UsersState {
    switch (action.type) {
        default:
            return {
                ...state,
                crud: crudReducer(name, state.crud, action)
            }
    }
}
